import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { User, Register, Login, Office } from './user.model';

@Injectable()
export class UserService {
  //readonly rootUrl = "http://localhost:14055";


   readonly rootUrl = 'http://telemedicineapi.esdinfra.com';  
  httpOptions: any;

  constructor(private http: HttpClient) {
    let accesstoken = localStorage.getItem('accessToken');
    if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accesstoken,
          'No-Auth': 'True'
        })
      };
    }
  }

  getAllowedPages() {
    debugger
    let accesstoken = localStorage.getItem('accessToken');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.rootUrl + '/api/AllowedPages', this.httpOptions);
  }
  userAuthentication(user?: Login) {
    debugger;
    var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password";
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
    }
    return this.http.post(this.rootUrl + '/token', data, httpOptions);
  }
  getAllRoles(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    debugger;
    return this.http.get(this.rootUrl + '/api/Claims/' + roleId,this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Roles/' + roleId, this.httpOptions);
  }
  getUserForTheId(Id: string) {
    return this.http.get(this.rootUrl + '/api/Users/' + Id, this.httpOptions);
  }
  getOfficeForTheId(OfficeId: string) {
    return this.http.get(this.rootUrl + '/api/Offices/' + OfficeId, this.httpOptions);
  }
  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  GetAllRoleNames() {
    return this.http.get(this.rootUrl + '/api/Roles/GetAllOffices/', this.httpOptions);
  }
  getAllDistrictName() {
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrict', this.httpOptions);
  }
  GetAllStates() {
    return this.http.get(this.rootUrl + '/api/Users/GetAllStates', this.httpOptions);
  }
  GetAllDistrictById(ID: any) {
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrictById/' + ID, this.httpOptions);
  }
  getRolesforSelectedOffice() {
    return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice', this.httpOptions);
  }
  GetAllOffices(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  registerUser(register: Register) {
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }
  registerCustomer(register: Register) {
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }
  VerifyMobileNo(Mob_No: any) {
    return this.http.put(this.rootUrl + '/api/Users/VerifyMobileNo/' + Mob_No + "/", this.httpOptions);
  }
  createRole(user: User) {
    return this.http.post(this.rootUrl + '/api/Roles/Create', user, this.httpOptions);
  }
  updateRole(user: User, roleId: string) {
    return this.http.put(this.rootUrl + '/api/Roles/Update/' + roleId, user, this.httpOptions);
  }
  searchRoles(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  searchUsers(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  searchOffices(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  updateOffice(office: Office, OfficeId: string) {
    return this.http.put(this.rootUrl + '/api/Offices/Update/' + OfficeId, office, this.httpOptions);
  }
  saveClaims(claimsList, roleId) {
    return this.http.put(this.rootUrl + '/api/Claims/' + roleId + '/assignClaims', claimsList, this.httpOptions);
  }
  CreateOffice(office: Office) {
    return this.http.post(this.rootUrl + '/api/Offices/Create', office, this.httpOptions);
  }
  changePassword(userDetails: any) {
    return this.http.post(this.rootUrl + '/api/Account/ChangePassword', userDetails, this.httpOptions);
  }
  changePasswordForTheId(userDetails: any) {
    return this.http.put(this.rootUrl + '/api/Account/Update', userDetails, this.httpOptions);
  }
  deleteRole(id: string) {
    return this.http.put(this.rootUrl + '/api/Roles/Delete/' + id, this.httpOptions);
  }
  activateInactivateUser(id: string) {
    return this.http.put(this.rootUrl + '/api/Users/ActivateInactivate/' + id, null, this.httpOptions);
  }
  activateInactivateRoles(id: string) {
    return this.http.put(this.rootUrl + '/api/Roles/ActivateInactivate/' + id, null, this.httpOptions);
  }
  activateInactivateOffices(id: string) {
    return this.http.put(this.rootUrl + '/api/Offices/ActivateInactivate/' + id, null, this.httpOptions);
  }

  // surya dummy data list
  // getEmpList(id) {
  //   return this.http.get(this.empList + '/' + id);
  // }
  empList: any = [
    { 'emp_code': '1032', 'name': 'Surya', 'dob': '01/09/1994', 'doj': '01-09-2020', 'status': 'Active' },
    { 'emp_code': '1033', 'name': 'Sathya', 'dob': '01/09/1995', 'doj': '01-11-2020', 'status': 'Active' },
    { 'emp_code': '1034', 'name': 'Deepak', 'dob': '01/09/1992', 'doj': '01-09-2018', 'status': 'Active' },
    { 'emp_code': '1035', 'name': 'Prakash', 'dob': '01/09/1990', 'doj': '01-09-2016', 'status': 'Active' }
  ]

////////////////////////////////////////////////////////////////////////////////////
  GetAllDoctorDetails() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Doctor/GetAllDoctorDetails',this.httpOptions);
  } 

  GetHospitalDropDown() {
    return this.http.get(this.rootUrl + '/api/Doctor/GetHospitalForDropDown', this.httpOptions);
  }

  GetQualificationDropDown() {
    return this.http.get(this.rootUrl + '/api/Doctor/GetQualificationDropDown', this.httpOptions);
  }

  GetDesignationDropDown() {
    return this.http.get(this.rootUrl + '/api/Doctor/GetDesignationDropDown', this.httpOptions);
  }

  GetClinicalDisciplineDropDown() {
    return this.http.get(this.rootUrl + '/api/Doctor/GetClinicalDisciplineDropDown', this.httpOptions);
  }

  GetSpecializationDropDown() {
    return this.http.get(this.rootUrl + '/api/Doctor/GetSpecializationDropDown', this.httpOptions);
  }

  GetStateDropDown() {
    return this.http.get(this.rootUrl + '/api/Doctor/GetStateDropDown', this.httpOptions);
  }

  GetDistrictDropDown() {
    return this.http.get(this.rootUrl + '/api/Doctor/GetDistrictDropDown', this.httpOptions);
  }

  CreateDoctorDetails(Doctor) {
    return this.http.post(this.rootUrl + '/api/Doctor/CreateDoctor', Doctor, this.httpOptions);
  }

  GetByIdDoctorModel(DO_Id) {
    return this.http.get(this.rootUrl + '/api/Doctor/GetByIdDoctorDetails/' + DO_Id, this.httpOptions);
  }

  UpdateDoctor(DO_Id, Doctor) {
    return this.http.put(this.rootUrl + '/api/Doctor/UpdateDoctor/' + DO_Id, Doctor, this.httpOptions);
  }

  DeleteDoctorDetails(DO_Id) {
    return this.http.delete(this.rootUrl + '/api/Doctor/DeleteDoctorDetails/' + DO_Id, this.httpOptions);
  }

  GetAllQualificationDetails() {
    return this.http.get(this.rootUrl + '/api/qualification/GetAllQualificationDetails',this.httpOptions);
  } 

  CreateQualification(Qualification) {
    return this.http.post(this.rootUrl + '/api/qualification/CreateQualification', Qualification, this.httpOptions);
  }

  GetByIdQualificationDetails(QU_Id) {
    return this.http.get(this.rootUrl + '/api/qualification/GetByIdQualificationDetails/' + QU_Id, this.httpOptions);
  }

  UpdateQualification(QU_Id, Qualification) {
    return this.http.put(this.rootUrl + '/api/qualification/UpdateQualification/' + QU_Id, Qualification, this.httpOptions);
  }

  DeleteQualificationDetails(QU_Id) {
    return this.http.delete(this.rootUrl + '/api/qualification/DeleteQualificationDetails/' + QU_Id, this.httpOptions);
  }

  GetAllClinicalDiscipline() {
    return this.http.get(this.rootUrl + '/api/discipline/GetAllClinicalDiscipline',this.httpOptions);
  } 

  CreateDiscipline(Discipline) {
    return this.http.post(this.rootUrl + '/api/discipline/CreateDiscipline', Discipline, this.httpOptions);
  }

  GetByIdClinicalDiscipline(CD_Id) {
    return this.http.get(this.rootUrl + '/api/discipline/GetByIdClinicalDiscipline/' + CD_Id, this.httpOptions);
  }

  UpdateDiscipline(CD_Id, Discipline) {
    return this.http.put(this.rootUrl + '/api/discipline/UpdateDiscipline/' + CD_Id, Discipline, this.httpOptions);
  }

  DeleteDiscipline(CD_Id) {
    return this.http.delete(this.rootUrl + '/api/discipline/DeleteDiscipline/' + CD_Id, this.httpOptions);
  }

  GetAllDistrict() {
    return this.http.get(this.rootUrl + '/api/District/GetAllDistrict',this.httpOptions);
  } 

  CreateDistrict(District) {
    return this.http.post(this.rootUrl + '/api/District/CreateDistrict', District, this.httpOptions);
  }

  GetByIdDistrict(DI_Id) {
    return this.http.get(this.rootUrl + '/api/District/GetByIdDistrict/' + DI_Id, this.httpOptions);
  }

  UpdateDistrict(DI_Id, District) {
    return this.http.put(this.rootUrl + '/api/District/UpdateDistrict/' + DI_Id, District, this.httpOptions);
  }

  DeleteDistrict(DI_Id) {
    return this.http.delete(this.rootUrl + '/api/District/DeleteDistrict/' + DI_Id, this.httpOptions);
  }

  GetAllNetwork() {
    return this.http.get(this.rootUrl + '/api/Network/GetAllNetwork',this.httpOptions);
  } 

  CreateNetwork(Network) {
    return this.http.post(this.rootUrl + '/api/Network/CreateNetwork', Network, this.httpOptions);
  }

  GetByIdNetwork(NE_Id) {
    return this.http.get(this.rootUrl + '/api/Network/GetByIdNetwork/' + NE_Id, this.httpOptions);
  }

  UpdateNetwork(NE_Id, Network) {
    return this.http.put(this.rootUrl + '/api/Network/UpdateNetwork/' + NE_Id, Network, this.httpOptions);
  }

  DeleteNetwork(NE_Id) {
    return this.http.delete(this.rootUrl + '/api/Network/DeleteNetwork/' + NE_Id, this.httpOptions);
  }

  DeletePatient(PR_Id) {
    return this.http.delete(this.rootUrl + '/api/Patient/DeletePatient/' + PR_Id, this.httpOptions);
  }

  GetAllPatient() {
    return this.http.get(this.rootUrl + '/api/Patient/GetAllPatient',this.httpOptions);
  } 

  CreatePatient(Patient) {
    return this.http.post(this.rootUrl + '/api/Patient/CreatePatient', Patient, this.httpOptions);
  }

  GetDocumentDropDown() {
    return this.http.get(this.rootUrl + '/api/Patient/GetDocumentDropDown', this.httpOptions);
  }
  
  uploadImageRecovery(data) {
    return this.http.post(this.rootUrl + '/api/Patient/image', data);
  }

  GetByIdPatient(PR_Id) {
    return this.http.get(this.rootUrl + '/api/Patient/GetByIdPatient/' + PR_Id, this.httpOptions);
  }

  UpdatePatient(PR_Id, Patient) {
    return this.http.put(this.rootUrl + '/api/Patient/UpdatePatient/' + PR_Id, Patient, this.httpOptions);
  }

  calculateAge(dateOfBirth) {
    return this.http.get(this.rootUrl + '/api/Patient/calculateAge/' + dateOfBirth, this.httpOptions);
  }

  GetPatientDropDown() {
    return this.http.get(this.rootUrl + '/api/ExistingPatient/GetPatientDropDown', this.httpOptions);
  }

  GetDoctorDropDown() {
    return this.http.get(this.rootUrl + '/api/ExistingPatient/GetDoctorDropDown', this.httpOptions);
  }

  GetByIdExistingPatient(PR_Id) {
    return this.http.get(this.rootUrl + '/api/ExistingPatient/GetByIdExistingPatient/' + PR_Id, this.httpOptions);
  }

  CreateExistingPatient(ExistingPatient) {
    debugger;
    return this.http.post(this.rootUrl + '/api/ExistingPatient/CreateExistingPatient', ExistingPatient, this.httpOptions);
  }

  GetAllExistingPatient() {
    return this.http.get(this.rootUrl + '/api/ExistingPatient/GetAllExistingPatient',this.httpOptions);
  } 

  GetAllConsultancy() {
    return this.http.get(this.rootUrl + '/api/Consultancy/GetAllConsultancy',this.httpOptions);
  } 

  GetByIdConsultancyDetails(PR_Id) {
    return this.http.get(this.rootUrl + '/api/Consultancy/GetByIdConsultancyDetails/' + PR_Id, this.httpOptions);
  }

  GetConsultancyClinicalDisciplineDropDown() {
    return this.http.get(this.rootUrl + '/api/Consultancy/GetConsultancyClinicalDisciplineDropDown', this.httpOptions);
  }

  GetConsultancySpecializationDropDown() {
    return this.http.get(this.rootUrl + '/api/Consultancy/GetConsultancySpecializationDropDown', this.httpOptions);
  }

  GetConsultancyHospitalDropDown() {
    return this.http.get(this.rootUrl + '/api/Consultancy/GetConsultancyHospitalDropDown', this.httpOptions);
  }

  CreateConsultancyDetails(Consultancy) {
    return this.http.post(this.rootUrl + '/api/Consultancy/CreateConsultancyDetails', Consultancy, this.httpOptions);
  }

  GetClinicalDisciplineDown() {
    return this.http.get(this.rootUrl + '/api/ExistingPatient/GetClinicalDisciplineDown', this.httpOptions);
  }
  /////////////////////////////////////////////////////////////////////////////////////

  GetallDetails() {
    
    return this.http.get(this.rootUrl + '/api/Assistant/PageNo/', this.httpOptions);
  }
  GetallDesignation() {
  
    return this.http.get(this.rootUrl + '/api/designation/PageNo/', this.httpOptions);
  }
  GetallSpicalization() {
    
    return this.http.get(this.rootUrl + '/api/specialization/PageNo/', this.httpOptions);
  }
  Getallhosptal() {
   
    return this.http.get(this.rootUrl + '/api/Hospital/PageNo/', this.httpOptions);
  }
  Getallstate() {

    return this.http.get(this.rootUrl + '/api/state/PageNo/', this.httpOptions);
  }
  Getallvender() {
    
    return this.http.get(this.rootUrl + '/api/vendor/PageNo/', this.httpOptions);
  }
  GetallPatient() {
    
    return this.http.get(this.rootUrl + '/api/Patient/PageNo/', this.httpOptions);
  }
  // GetByIdDistrict(id) {
  //   return this.http.get(this.rootUrl + '/api/Assistant/details/' + id, this.httpOptions);
  // }
  PostFormone(udm) {
    return this.http.post(this.rootUrl + '/api/Assistant/CreateAssistant', udm, this.httpOptions);
  }
  Postvender(udm) {
    return this.http.post(this.rootUrl + '/api/Vendor/CreateVendor', udm, this.httpOptions);
  }
  Posthosptal(udm) {
    return this.http.post(this.rootUrl + '/api/Hospital/CreateHospital', udm, this.httpOptions);
  }

  Poststate(udm) {
    return this.http.post(this.rootUrl + '/api/state/Createstate', udm, this.httpOptions);
  }
  Postspicilization(udm) {
    return this.http.post(this.rootUrl + '/api/specialization/CreateSpecialization', udm, this.httpOptions);
  }
  Postdesignation(udm) {
    return this.http.post(this.rootUrl + '/api/designation/CreateAssistant', udm, this.httpOptions);
  }
  DeleteAssistant(id: string) {
    return this.http.put(this.rootUrl + '/api/Assistant/DeleteAssistant/' + id, null, this.httpOptions);
  }
  Deletedesignation(id: string) {
    return this.http.put(this.rootUrl + '/api/designation/DeleteDesignation/' + id, null, this.httpOptions);
  }
  DeletedSpacalization(id: string) {
    return this.http.put(this.rootUrl + '/api/specialization/DeletSpecialization/' + id, null, this.httpOptions);
  }
 
  DeletedState(id: string) {
    return this.http.put(this.rootUrl + '/api/state/Deletstate/' + id, null, this.httpOptions);
  }
  Deletedvender(id: string) {
    return this.http.put(this.rootUrl + '/api/vendor/DeletVendor/' + id, null, this.httpOptions);
  }
  DeletedPatient(id: string) {
    return this.http.put(this.rootUrl + '/api/Patient/DeletPatient/' + id, null, this.httpOptions);
  }
  Deletedhospal(id: string) {
    return this.http.put(this.rootUrl + '/api/Hospital/DeletHospital/' + id, null, this.httpOptions);
  }
  
  GetCategory() {
    return this.http.get(this.rootUrl + '/api/Assistant/GetAllss/' + "/", this.httpOptions);
  }
  GetallCategoryDropDownDetails() {
    return this.http.get(this.rootUrl + '/api/Assistant/GetAllFormCategoryDetailsForDropdown/' + "/", this.httpOptions);
  }
  GetallCategoryDropDown() {
    return this.http.get(this.rootUrl + '/api/Assistant/GetAllDrop/' + "/", this.httpOptions);
  }
  Getallnetwork() {
    return this.http.get(this.rootUrl + '/api/Hospital/GetAllDrops/' + "/", this.httpOptions);
  }
  GetallCategoryDrop() {
    return this.http.get(this.rootUrl + '/api/Assistant/GetAllFormCategory/' + "/", this.httpOptions);
  }
  Getallspicilization() {
    return this.http.get(this.rootUrl + '/api/specialization/GetAllDrop/' + "/", this.httpOptions);
  }
  GetallCategory() {
    return this.http.get(this.rootUrl + '/api/Assistant/GetAllFormCategoryDetails/' + "/", this.httpOptions);
  }
  GetallCategorydrop() {
    return this.http.get(this.rootUrl + '/api/Assistant/GetAllFormCategoryDetailsFor/' + "/", this.httpOptions);
  }
  GetallVLE() {
    
    return this.http.get(this.rootUrl + '/api/VLE/PageNo/', this.httpOptions);
  }

DeleteVLE(id: string) {
    return this.http.put(this.rootUrl + '/api/VLE/DeleteVLE/' + id, null, this.httpOptions);
  }

 PostVLE(udm) {
    return this.http.post(this.rootUrl + '/api/VLE/CreateVLE', udm, this.httpOptions);
  }

 updateVLE(udm, AS_Id: any) {
    return this.http.put(this.rootUrl + '/api/VLE/Update/' +  AS_Id,udm, this.httpOptions);
  }
getbyVLE(id) {
    return this.http.get(this.rootUrl + '/Api/VLE/details/' + "/" + id, this.httpOptions);

  }
  // surya dummy data list
  getEmpList(id) {
    return this.http.get(this.empList + '/' + id);
  }
  uploadImagesFile(data) {
    return this.http.post(this.rootUrl + '/api/Assistant/images', data);
  }
  getbyactiveForm(id) {
    return this.http.get(this.rootUrl + '/Api/specialization/detailsSpecialization/' + "/" + id, this.httpOptions);

  }
  getbyassistence(id) {
    return this.http.get(this.rootUrl + '/Api/Assistant/details/' + "/" + id, this.httpOptions);

  }
  getbyvender(id) {
    return this.http.get(this.rootUrl + '/Api/Vendor/detailsVendor/' + "/" + id, this.httpOptions);

  }
  getbyhospital(id) {
    return this.http.get(this.rootUrl + '/Api/Hospital/detailsHospital/' + "/" + id, this.httpOptions);

  }
  getbyState(id) {
    return this.http.get(this.rootUrl + '/Api/state/detailsstate/' + "/" + id, this.httpOptions);

  }
  getbyDesignation(id) {
    return this.http.get(this.rootUrl + '/Api/designation/detailDesignation/' + "/" + id, this.httpOptions);

  }
  
  updateAssistance(udm, AS_Id: any) {
    return this.http.put(this.rootUrl + '/api/Assistant/Update/' +  AS_Id,udm, this.httpOptions);
  }
  updatevender(udm, AS_Id: any) {
    return this.http.put(this.rootUrl + '/api/Vendor/UpdateVendor/' +  AS_Id,udm, this.httpOptions);
  }
  updatehospital(udm, HO_Id: any) {
    return this.http.put(this.rootUrl + '/api/Hospital/UpdateHospital/' +HO_Id ,udm,  this.httpOptions);
  }
  updatestate(udm, ST_Id: any) {
    return this.http.put(this.rootUrl + '/api/state/Updatestate/' +ST_Id ,udm,  this.httpOptions);
  }
  updatespicilization(udm, SP_Id: any) {
    return this.http.put(this.rootUrl + '/api/specialization/UpdateSpecialization/' +  SP_Id,udm, this.httpOptions);
  }
  updatedesignation(udm, DE_Id: any) {
   
    return this.http.put(this.rootUrl + '/api/designation/UpdateDesignation/' + DE_Id,udm, this.httpOptions);
  }

    //Doctor

    GetAllSpecialities() {
      return this.http.get(this.rootUrl + '/api/Users/GetAllSpeicality', this.httpOptions);
    }
  
    registerCustomerAcc(register: Register) {
      return this.http.post(this.rootUrl + '/api/Account/RegisterAcc', register, this.httpOptions);
    }
  
    GetAllBusinessTypeList() {
      return this.http.get(this.rootUrl + '/api/Users/GetAllBusinessTypeList', this.httpOptions);
    }
  
    GetAllProductCategoryList() {
      return this.http.get(this.rootUrl + '/api/Users/GetAllProductCategoryList', this.httpOptions);
    }
    CreatePatient1(Patient) {
      return this.http.post(this.rootUrl + '/api/Patient/CreatePatient1', Patient, this.httpOptions);
    }

    // GetPatientByid(name) {
    //   return this.http.get(this.rootUrl + '/api/Doctor/GetDistrictDropDown', this.httpOptions);
    // }
    // GetPatientByid(name) {
    //   return this.http.get(this.rootUrl + '/Api/designation/detailDesignation/' + "/" + name, this.httpOptions);
  
    // }

    GetPatientByid(name) {
      return this.http.get(this.rootUrl + '/api/Patient/GetByIdPatient/' + name, this.httpOptions);
    }

    // checkBudgetYearAlreadyExist(Mob_No:any,Name:any){  
    //   return this.http.get(this.rootUrl+"api/Users/CheckusermobileAlreadyExist/"+Mob_No,+Name this.httpOptions);
    // }

    checkuseAlreadyExist(Mob_No: any, Name: any) {
      return this.http.get(this.rootUrl + '/api/Users/CheckusermobileAlreadyExist/' + Mob_No+"/"+Name , this.httpOptions);
    } 

    GetDoctorDropDownlist() {
      return this.http.get(this.rootUrl + '/api/Consultancy/GetDoctorDropDown', this.httpOptions);
    }

    GetAllPharamacy() {
      return this.http.get(this.rootUrl + '/api/Consultancy/GetAllPharamacy',this.httpOptions);
    } 

    // GetAllPrescription(id:any) {
    //   return this.http.get(this.rootUrl + '/api/Consultancy/GetAllPrescription/' +id,this.httpOptions);
    // } 
    GetAllPrescription(id) {
      debugger;
      return this.http.get(this.rootUrl + '/Api/Consultancy/GetAllPrescription/' + id, this.httpOptions);
  
    }
   
    CreatePharamcyrequest(Consultancy) {
      return this.http.post(this.rootUrl + '/api/Consultancy/Createpharamcyrequestls', Consultancy, this.httpOptions);
    }

    GetByIdpharamacyrequests(id) {
      debugger;
      return this.http.get(this.rootUrl + '/Api/Consultancy/GetByIdpharamacyrequests/' + id, this.httpOptions);
  
    }


    //Health Records

    GetHealthRecords(PR_Id) {
      return this.http.get(this.rootUrl + '/api/Patient/GetHealthRecords/' + PR_Id, this.httpOptions);
    }
    
//  Dignostic
GetAllDignostic(id) {
  debugger;
  return this.http.get(this.rootUrl + '/Api/Consultancy/GetAllDignostic/' + id, this.httpOptions);

}

GetByIdDiagnpharamacyrequests(id) {
  debugger;
  return this.http.get(this.rootUrl + '/Api/Consultancy/GetByIdDiagnpharamacyrequests/' + id, this.httpOptions);

}


CreateDignosticrequest(Consultancy) {
  return this.http.post(this.rootUrl + '/api/Consultancy/CreateDignopharamcyrequestls', Consultancy, this.httpOptions);
}
  

GetAllNtwrkHospDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Doctor/GetAllhospitalnetworkDetails',this.httpOptions);
} 

GetAllSpecilHospDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Doctor/GetAllspecialityhospitalDetails',this.httpOptions);
} 

GetAllntwrkDoctorDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Doctor/GetAllnetwrkDoctorDetails',this.httpOptions);
}
GetAllspecialDoctorDetails() {
  debugger;
  return this.http.get(this.rootUrl + '/api/Doctor/GetAllspecialDoctorDetails',this.httpOptions);
}


GetByIdusernam(UserName) {
  return this.http.get(this.rootUrl + '/api/Account/GetByIdusercat/' + UserName, this.httpOptions);
}
}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts